<template>
    <div>
        <ContactThanks />
    </div>
</template>

<script>

import ContactThanks from '../contact-us/ContactThanks'


export default {
    components: {
        ContactThanks
    }
}
</script>
